export const geographyConstants = {
	GEO_REQUEST: 'GEO_REQUEST',
	GEO_SUCCESS: 'GEO_SUCCESS',
	GEO_ERROR: 'GEO_ERROR'
};
